<app-digital-templates-container #container [title]="'Digital Templates'">
  <app-tab-bar
    #tabController
    [tabs]="viewModel.tabs$ | async"
    (selectedTab)="container.tabSelected($event)"></app-tab-bar>
</app-digital-templates-container>
